import { render, staticRenderFns } from "./productionDashboard.vue?vue&type=template&id=d9cc0146&"
import script from "./productionDashboard.vue?vue&type=script&lang=js&"
export * from "./productionDashboard.vue?vue&type=script&lang=js&"
import style0 from "./productionDashboard.vue?vue&type=style&index=0&id=d9cc0146&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports